import axios from '@/http/axios';
import {route} from '@/http/ziggy';

/**
 * Fetch artifact dataset comments.
 *
 * @param {Number} experiment
 * @param {Number} artifactDataset
 * @return {Promise}
 */
export const index = ({experiment, artifactDataset}) => axios.get(route('catchers.core.artifacts_dataset.comments.index', {experiment, artifactDataset}))

/**
 * Store comment on an artifact dataset.
 *
 * @param {Number} experiment
 * @param {Number} artifactDataset
 * @param {String} comment
 * @return {Promise}
 */
export const store = ({experiment, artifactDataset, comment}) => axios.post(route('catchers.core.artifacts_dataset.comments.store', {experiment, artifactDataset}), {comment})

export default {
  index,
  store
}
